// React
import { createContext } from "react"

export const PictureContext = createContext<{
  data: string | null
  isLoading: boolean
}>({
  data: null,
  isLoading: false
})